'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _Grid = require('@material-ui/core/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
var _MailOutline = require('@material-ui/icons/MailOutline');
var _MailOutline2 = _interopRequireDefault(_MailOutline);
var _TextField = require('@material-ui/core/TextField');
var _TextField2 = _interopRequireDefault(_TextField);
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _reactI18next = require('react-i18next');
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _ExpandableText = require('../ExpandableText');
var _ExpandableText2 = _interopRequireDefault(_ExpandableText);
var _Paginator = require('../Paginator');
var _Paginator2 = _interopRequireDefault(_Paginator);
var _manageSpeakerState = require('./manageSpeakerState');
var _manageSpeakerState2 = _interopRequireDefault(_manageSpeakerState);
var _CustomModal = require('../CustomModal');
var _CustomModal2 = _interopRequireDefault(_CustomModal);
var _SpeakerModalContent = require('../SpeakerModalContent');
var _SpeakerModalContent2 = _interopRequireDefault(_SpeakerModalContent);
var _xTwitter = require('../../assets/icons/x-twitter.svg');
var _xTwitter2 = _interopRequireDefault(_xTwitter);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var urlRegexp = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
var styles = {
  SpeakerList: {},
  grid: {},
  progress: {
    color: 'white'
  },
  buttonRow: {
    textAlign: 'center'
  },
  inputRow: {
    marginTop: 32
  },
  button: {
    height: '3rem',
    border: function border(_ref) {
      var buttonColor = _ref.otherProperties.buttonColor;
      return '2px solid ' + (buttonColor || '#FDAB2B');
    },
    fontWeight: 'bold',
    textTransform: 'capitalize',
    margin: '0.5rem',
    fontFamily: 'inherit'
  },
  searchButton: {
    color: '#FFFFFF',
    margin: '1rem',
    backgroundColor: function backgroundColor(_ref2) {
      var buttonColor = _ref2.otherProperties.buttonColor;
      return buttonColor || '#FDAB2B';
    },
    '&:hover': {
      backgroundColor: function backgroundColor(_ref3) {
        var buttonColor = _ref3.otherProperties.buttonColor;
        return buttonColor || '#FDAB2B';
      }
    }
  },
  resetButton: {
    color: function color(_ref4) {
      var buttonColor = _ref4.otherProperties.buttonColor;
      return buttonColor || '#FDAB2B';
    },
    margin: '1rem',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF'
    }
  },
  keywordsRoot: {
    fontFamily: 'inherit',
    margin: 'auto',
    maxWidth: 300,
    marginBottom: '1rem',
    '& label': {
      color: '#BFBFBF',
      fontWeight: 'normal'
    }
  },
  keywordsInput: {
    '&::placeholder': {
      fontWeight: 'normal',
      color: '#BFBFBF',
      padding: '0 0 0 1rem',
      opacity: '1' /* Firefox */
    },

    '&:-ms-input-placeholder': {
      /* Internet Explorer 10-11 */
      fontWeight: 'normal',
      color: '#BFBFBF',
      padding: '0 0 0 1rem'
    },
    '&::-ms-input-placeholder': {
      /* Microsoft Edge */
      fontWeight: 'normal',
      color: '#BFBFBF',
      padding: '0 0 0 1rem'
    }
  },
  speakerContainer: {
    display: 'flex'
  },
  speaker: {
    display: 'flex',
    width: '100%',
    minHeight: '15rem',
    '&.right': {
      flexDirection: 'row-reverse',
      textAlign: 'right',
      '& .email': {
        flexDirection: 'row-reverse',
        '& > svg': {
          margin: '0 0 0 8px'
        }
      }
    },
    '& p': {
      margin: '16px 0'
    },
    '& span': {
      display: 'block'
    },
    '& .picture': {
      width: '50%',
      height: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    '& .details': {
      width: '50%',
      '& > div': {
        margin: function margin(_ref5) {
          var responsiveMode = _ref5.responsiveMode;
          return responsiveMode === _ResponsiveModes.DESKTOP ? '2rem 2.5rem' : '1.5rem 2rem';
        }
      },
      '&.dark': {
        '& .name': {
          color: 'black'
        },
        '& .position, & .bio, & .email, & .company, & .more-info-button': {
          color: 'rgba(0, 0, 0, 0.8)'
        },
        '& .social-media': {
          '& a': {
            color: 'rgba(0, 0, 0, 0.8)'
          }
        }
      },
      '&.light': {
        '& .name': {
          color: 'white'
        },
        '& .position, & .bio, & .email, & .company, & .more-info-button': {
          color: 'rgba(255, 255, 255, 0.8)'
        },
        '& .social-media': {
          '& a': {
            color: 'rgba(255, 255, 255, 0.8)'
          }
        }
      }
    },
    '& .name': {
      fontSize: '1.3rem'
    },
    '& .position': {
      marginTop: 8,
      fontSize: '0.8rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },
    '& .company': {
      fontSize: '0.8rem'
    },
    '& .bio': {
      marginTop: 16,
      fontSize: '0.9rem',
      overflow: 'hidden'
    },
    '& .more-info-button': {
      cursor: 'pointer'
    },
    '& .social-media': {
      marginTop: 16,
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
      '&.right': {
        justifyContent: 'flex-end'
      },
      '& > a': {
        borderRadius: '50%',
        margin: 4,
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.25rem',
        textDecoration: 'none'
      },
      '& svg': {
        width: '1.25rem',
        height: '1.25rem'
      }
    },
    '& .email': {
      marginTop: 10,
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.8rem',
      overflow: 'hidden',
      wordBreak: 'break-all',
      '& > svg': {
        marginRight: 8
      },
      '& > a': {
        color: 'inherit',
        textDecoration: 'none'
      }
    }
  }
};
var maxLetters = 200;
var SpeakerTiles = function (_Component) {
  _inherits(SpeakerTiles, _Component);
  function SpeakerTiles(props) {
    _classCallCheck(this, SpeakerTiles);
    var _this = _possibleConstructorReturn(this, (SpeakerTiles.__proto__ || Object.getPrototypeOf(SpeakerTiles)).call(this, props));
    _this.handleClose = function () {
      _this.setState({
        currentSId: 0
      });
    };
    _this.showModal = function (id) {
      _this.setState({
        currentSId: id
      });
    };
    _this.isExpanded = function (speaker, expanded) {
      return expanded.indexOf(speaker.id) > -1;
    };
    _this.canExpand = function (speaker) {
      return speaker.bio.length >= maxLetters;
    };
    _this.getDescription = function (speaker, expanded) {
      if (_this.isExpanded(speaker, expanded) || !_this.canExpand(speaker)) {
        return speaker.bio;
      } else {
        return speaker.bio.substring(0, maxLetters) + '...';
      }
    };
    _this.getTextColorByBackgroundColor = function (color) {
      var r = color.r,
        g = color.g,
        b = color.b,
        a = color.a;
      return (parseInt(r) + parseInt(g) + parseInt(b)) * parseInt(a) >= 333 ? 'dark' : 'light';
    };
    _this.RGBAToFormatedObject = function (color) {
      var r = color.r,
        g = color.g,
        b = color.b,
        a = color.a;
      return {
        background: 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')',
        text: _this.getTextColorByBackgroundColor(color)
      };
    };
    _this.getDetailsColor = function (index) {
      var coloursSelector = _this.props.otherProperties.coloursSelector;
      var colors = [{
        background: '#F5F5F5',
        text: 'dark'
      }, {
        background: '#FFC645',
        text: 'dark'
      }, {
        background: '#D0DCE1',
        text: 'dark'
      }, {
        background: '#212121',
        text: 'light'
      }, {
        background: '#614DAE',
        text: 'light'
      }, {
        background: '#FE5F37',
        text: 'light'
      }, {
        background: '#50E3C2',
        text: 'dark'
      }, {
        background: '#F5A623',
        text: 'light'
      }];
      if (!!coloursSelector && coloursSelector.length > 0) {
        index = index % coloursSelector.length;
        var colorSelected = index >= coloursSelector.length ? coloursSelector[index - coloursSelector.length] : coloursSelector[index];
        return _this.RGBAToFormatedObject(colorSelected);
      } else {
        index = index % 8;
        return index >= colors.length ? colors[index - colors.length] : colors[index];
      }
    };
    _this.handleChangeKeywords = function (event) {
      _this.setState({
        keywords: event.target.value
      });
    };
    _this.handleSubmit = function () {
      var keywords = _this.state.keywords;
      if (keywords) _this.props.fetchPage(null, {
        keywords: keywords
      });
    };
    _this.resetSearch = function () {
      _this.setState({
        keywords: ''
      });
      _this.props.fetchPage();
    };
    _this.state = {
      currentSId: 0,
      keywords: ''
    };
    _this.wrapperRef = _react2.default.createRef();
    return _this;
  }
  _createClass(SpeakerTiles, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var otherProperties = this.props.otherProperties;
      var speakerPaginationSize = otherProperties.speakerPaginationSize;
      if (prevProps.otherProperties.speakerPaginationSize != speakerPaginationSize) {
        this.props.fetchPage();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        entities = _props.entities,
        pagination = _props.pagination,
        expanded = _props.expanded,
        toggleExpanded = _props.toggleExpanded,
        fetchPage = _props.fetchPage,
        responsiveMode = _props.responsiveMode,
        t = _props.t,
        otherProperties = _props.otherProperties;
      var isFetching = pagination.isFetching,
        idsByPage = pagination.idsByPage,
        links = pagination.links;
      var hideSearchField = otherProperties.hideSearchField;
      var currentPage = links.self;
      var speakers = !!idsByPage && !!idsByPage[currentPage] && idsByPage[currentPage].map(function (id) {
        return entities[id];
      });
      var column_size = null;
      switch (responsiveMode) {
        case _ResponsiveModes.DESKTOP:
        case _ResponsiveModes.TABLET:
          column_size = 6;
          break;
        case _ResponsiveModes.MOBILE:
        default:
          column_size = 12;
      }
      var tiles_orientation_aux = 0;
      var modalPictureStyle = void 0,
        modalSpeaker = void 0;
      if (!!this.state.currentSId && !!entities && !!entities[this.state.currentSId]) {
        modalSpeaker = entities[this.state.currentSId];
        modalPictureStyle = {
          backgroundImage: 'url(' + (modalSpeaker.picture.filename ? modalSpeaker.picture.small : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/avatar.png') + ')'
        };
      }
      return _react2.default.createElement('div', {
        className: classes.SpeakerList,
        style: cssProperties,
        ref: this.wrapperRef
      }, !!this.state.currentSId && _react2.default.createElement(_CustomModal2.default, {
        onClose: this.handleClose
      }, _react2.default.createElement(_SpeakerModalContent2.default, {
        speaker: modalSpeaker,
        imgStyle: modalPictureStyle
      })), _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.grid,
        spacing: 0
      }, typeof hideSearchField !== 'undefined' && !hideSearchField && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12,
        className: classes.inputRow
      }, _react2.default.createElement(_TextField2.default, {
        label: '',
        InputLabelProps: {
          shrink: true
        },
        placeholder: 'Keywords',
        value: this.state.keywords,
        onChange: this.handleChangeKeywords,
        fullWidth: true,
        InputProps: {
          classes: {
            root: classes.keywordsRoot,
            input: classes.keywordsInput
          }
        }
      })), _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12,
        className: classes.buttonRow
      }, _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        color: 'primary',
        className: (0, _classnames2.default)(classes.button, classes.searchButton),
        onClick: this.handleSubmit
      }, t('exhibitors.search')), _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        color: 'primary',
        className: (0, _classnames2.default)(classes.button, classes.resetButton),
        onClick: this.resetSearch
      }, t('exhibitors.reset')))), isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.progress,
        size: 50
      }) : speakers && !!speakers.length ? speakers.map(function (speaker, index) {
        var id = speaker.id,
          picture = speaker.picture,
          fullName = speaker.fullName,
          position = speaker.position,
          bio = speaker.bio,
          email = speaker.email,
          company = speaker.company,
          twitter = speaker.twitter,
          linkedin = speaker.linkedin,
          instagram = speaker.instagram;
        var colors = _this2.getDetailsColor(index);
        var picture_style = {
          backgroundImage: 'url(' + (picture.filename ? picture.large : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/avatar.png') + ')'
        };
        var details_style = {
          backgroundColor: colors.background
        };
        var tile_right_orientation = false;
        switch (responsiveMode) {
          case _ResponsiveModes.MOBILE:
            if (tiles_orientation_aux > 0) {
              tile_right_orientation = true;
              tiles_orientation_aux = 0;
              break;
            }
            tiles_orientation_aux++;
            break;
          default:
            if (tiles_orientation_aux > 1) tile_right_orientation = true;
            tiles_orientation_aux++;
            if (tiles_orientation_aux > 3) tiles_orientation_aux = 0;
            break;
        }
        return _react2.default.createElement(_Grid2.default, {
          className: classes.speakerContainer,
          item: true,
          xs: column_size,
          key: id
        }, _react2.default.createElement('div', {
          className: classes.speaker + ' ' + (tile_right_orientation ? 'right' : '')
        }, _react2.default.createElement('div', {
          className: 'picture',
          style: picture_style
        }), _react2.default.createElement('div', {
          className: 'details ' + colors.text,
          style: details_style
        }, _react2.default.createElement('div', null, _react2.default.createElement('div', {
          className: 'name'
        }, fullName), _react2.default.createElement('div', {
          className: 'company'
        }, company), _react2.default.createElement('div', {
          className: 'position'
        }, position), _react2.default.createElement('div', {
          className: 'social-media ' + (tile_right_orientation ? 'right' : '')
        }, twitter && _react2.default.createElement('a', {
          href: 'https://twitter.com/' + twitter,
          target: '_blank'
        }, _react2.default.createElement('svg', {
          fill: 'currentColor'
        }, _react2.default.createElement('use', {
          href: _xTwitter2.default + '#x-twitter-logo'
        }))), linkedin && _react2.default.createElement('a', {
          href: urlRegexp.test(linkedin) ? linkedin : 'https://www.linkedin.com/in/' + linkedin + '/',
          target: '_blank'
        }, _react2.default.createElement('i', {
          className: 'fa fa-linkedin-square'
        })), instagram && _react2.default.createElement('a', {
          href: 'https://www.instagram.com/' + instagram,
          target: '_blank'
        }, _react2.default.createElement('i', {
          className: 'fa fa-instagram'
        }))), _react2.default.createElement('div', {
          className: 'bio',
          dangerouslySetInnerHTML: {
            __html: _this2.getDescription(speaker, expanded)
          }
        }), _this2.canExpand(speaker) && _react2.default.createElement('a', {
          className: 'more-info-button',
          onClick: function onClick() {
            _this2.showModal(id);
          }
        }, _this2.isExpanded(speaker, expanded) ? t('text.less_info') : t('text.more_info')), email && _react2.default.createElement('div', {
          className: 'email'
        }, _react2.default.createElement(_MailOutline2.default, null), _react2.default.createElement('a', {
          href: 'mailto:' + email
        }, email))))));
      }) : _react2.default.createElement('h3', null, 'No speakers :(')), speakers && !!speakers.length && (links.next || links.prev) && _react2.default.createElement(_Paginator2.default, _extends({
        parentRef: this.wrapperRef,
        fetchPage: fetchPage
      }, links)));
    }
  }]);
  return SpeakerTiles;
}(_react.Component);
exports.default = (0, _manageSpeakerState2.default)()((0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(SpeakerTiles)));